import BaseApi from './../../libraries/baseApi';

export default class Api extends BaseApi {
    constructor() {
        super();
        this.test = false;
        this.url = '/api/ShoppingCartApi/';
    }

    getShoppingCart() {
        console.log(this._headers);

        return super.fetch(
            'getshoppingcart', 
            this.methods.get,
            {},
            {
                'cache': 'no-cache',
			    'credentials': 'include',
            }
        )
    }

    addProductToCart(id, count = 1) {
        return super.fetch(
            'addproducttocart',
            this.methods.post,
            {
                nodeId: parseInt(id),
                count: parseInt(count),
            },
            {
                'Content-Type': 'application/json',
            }
        ).then(response => {
            console.log(response);
            return response;
        });
    }

    DeleteProductFromCart(id) {
        return super.fetch(
            'deleteproductfromcart',
            this.methods.post,
            {
                cartItemId: parseInt(id)
            },
            {
                'Content-Type': 'application/json',
            }
        )
    }
}